<template>
    <v-tooltip
        v-if="showButtonTooltip"
        :text="tooltipText"
        location="top"
        content-class="button-tooltip"
        max-width="214"
    >
        <template #activator="{ props }">
            <button
                :class="btnStyle"
                @click="executeMethod"
                :disabled="disabled"
                v-bind="props"
                :data-cy="dataCy"
            >
                <span class="btn-content-wrapper">
                    <!-- Keep text for width but hide it when loading -->
                    <span
                        :class="textStyle"
                        :style="{
                            visibility: btnLoading ? 'hidden' : 'visible',
                        }"
                    >
                        {{ t(text ?? "default.empty") }}
                    </span>
                    <!-- Absolutely position the loader so it doesn't affect width -->
                    <div
                        v-if="btnLoading"
                        class="loading-dual-ring"
                        style="position: absolute"
                    ></div>
                </span>
            </button>
        </template>
    </v-tooltip>

    <button
        v-else
        :class="btnStyle"
        @click="executeMethod"
        :disabled="disabled"
        :data-cy="dataCy"
    >
        <span class="btn-content-wrapper">
            <!-- Keep text for width but hide it when loading -->
            <span
                :class="textStyle"
                :style="{
                    visibility: btnLoading ? 'hidden' : 'visible',
                }"
            >
                {{ t(text ?? "default.empty") }}
            </span>

            <!-- Absolutely position the loader so it doesn't affect width -->
            <div
                v-if="btnLoading"
                class="loading-dual-ring"
                style="position: absolute"
            ></div>
        </span>
    </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const componentProps = defineProps<{
    btnStyle?: string;
    text?: string;
    textStyle?: string;
    disabled?: boolean;
    btnLoading?: boolean;
    showTooltip?: boolean;
    tooltipMessage?: string;
    dataCy?: string;
}>();

const emit = defineEmits(["runMethod"]);
const executeMethod = () => {
    emit("runMethod");
};

const showButtonTooltip = computed(() => componentProps.showTooltip ?? false);
const tooltipText = computed(
    () => t(componentProps.tooltipMessage as string) ?? t("default.empty"),
);
</script>

<style>
.button-tooltip {
    padding: 8px 12px;
}
</style>
